import React, { useContext } from "react";
import { GlobalContext } from "contexts/GlobalStore.js";
import { IngredientBox } from "../IngredientBox/IngredientBox.js";

export const Ingredients = (props) => {
    const { data, keyName, additionalStyle, viewMode, removeButtonForIngsAndPacks } = props;
    const { errorText, alwaysNonEditable, currentValue } = data;
    const { turnArrayToLines } = useContext(GlobalContext);

    //-------------------------------------------------------------
    // 		RETURN
    //-------------------------------------------------------------
    if (!data || data === {}) {
        return null;
    } else {
        return (
            <div id={keyName} style={additionalStyle}>
                {/* LIST OF ADDED INGREDIENTS */}
                {!currentValue && viewMode === "view" ? (
                    <div style={{ marginLeft: 40 }}>There isn't any ingredient.</div>
                ) : !currentValue ? null : Object.entries(currentValue).length > 0 ? (
                    Object.entries(currentValue).map(([key, item]) => {
                        return (
                            <IngredientBox
                                viewMode={viewMode}
                                alwaysNonEditable={alwaysNonEditable}
                                key={key}
                                keyName={key}
                                currentAll={item}
                                remove={(additionalData) => {
                                    removeButtonForIngsAndPacks(additionalData);
                                }}
                            />
                        );
                    })
                ) : null}

                {/* ERROR TEXT */}
                {errorText?.length > 0 && viewMode !== "view" && alwaysNonEditable !== true ? (
                    <div className="form_errorText_on" style={{ marginBottom: 30 }}>
                        {turnArrayToLines(errorText)}
                    </div>
                ) : null}
            </div>
        );
    }
};
